import { Component, Input } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'placeholder-table',
  imports: [TableModule, SkeletonModule],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
export class PlaceholderTable {
  @Input() header: string[] = [];
}
